<template>
<div  class="addBox">
  <div class="detailsTitle">
    <h4>添加流程</h4>
    <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
    <el-form :inline="true" :rules="rules" :model="LCfrom" ref="LCfrom" class="demo-form-inline jiaoyan inpBox" label-width="140px" size="mini">
      <div class="addressBox">
        <h4 class="title">
          <span>基本信息</span>
        </h4>
        <div>
          <el-form-item label="流程名称:" prop="name">
            <el-input  placeholder="" maxlength="40" v-model="LCfrom.name" ></el-input>
          </el-form-item>
          <el-form-item label="适用仓库:" prop="organization" class="ck">
            <el-select  v-model="LCfrom.organization" value-key="tenantCode" disabled   placeholder="请选择" multiple>
              <el-option v-for="val in warehouseList" :label="val.tenantName" :value="val" :key="val.tenantCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型:" prop="formType1">
            <el-select  v-model="LCfrom.formType1"  placeholder="请选择" value-key="id">
              <el-option v-for="val in ywlx" :label="val.name" :value="val" :key="val.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批条件:" prop="tiaojian">
            <el-select  v-model="LCfrom.tiaojian"  placeholder="请选择" multiple @change="tjFn">
              <el-option v-for="val in sptj" :label="val.name" :value="val.id" :key="val.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  style="margin-left:26px">
            <el-button type="primary" @click="addNode">添加审批节点</el-button>
          </el-form-item>
        </div>
         <hr>
      </div>
      <div class="addressBox" v-for="(domain, index) in LCfrom.cFlowNodeList" :key="domain.key">
        <h4 class="title">
          <span>审批节点{{index+1}}</span>
        </h4>
        <div>
          <div class="treeBox">
            <el-form-item label="审批顺序:" :prop="'cFlowNodeList.' +index+ '.sortNum'" :key="'sortNum'+domain.index" >
              <el-input  placeholder="" class="disabled" :readonly="true" maxlength="10" v-model="domain.sortNum" ></el-input>
            </el-form-item>
            <el-form-item label="货物重量(吨):" v-if="LCfrom.tiaojian[0]==1||LCfrom.tiaojian.length==2" class="tiaojian"
            :prop="'cFlowNodeList.' +index+ '.minWeight'" :key="'minWeight'+domain.index" :rules="rules.minWeight">
            <span>≥</span><el-input  placeholder="" v-number-input.float="4" @blur="setWeight(index)"  maxlength="10" v-model="domain.minWeight" ></el-input>
            </el-form-item>
            <el-form-item label="货物件数(件):" v-if="LCfrom.tiaojian[0]==2||LCfrom.tiaojian.length==2" class="tiaojian"
             :prop="'cFlowNodeList.' +index+ '.minNum'" :key="'minNum'+domain.index" :rules="rules.minNum">
              <span>≥</span><el-input  placeholder="" v-number-input.float="0" @blur="setNum(index)"  maxlength="10" v-model="domain.minNum" ></el-input>
            </el-form-item>
            <el-form-item  >
               <el-button type="primary" @click="editFn(index)">审批人员</el-button>
              <!-- <span>{{domain.operationUserName}}</span><i  @click="editFn(index)" class="el-icon-edit editBtn"></i> -->
            </el-form-item>
            <el-form-item style="margin-left:26px">
            <el-button type="primary" @click="del(index)">删除</el-button>
          </el-form-item>
          </div>
         <div  v-for="(user, Uindex) in LCfrom.cFlowNodeList[index].nodeUserList" :key="Uindex" >
          <el-form-item label="审批人员:">
            <div style="min-width:150px">{{user.operationUserName}}</div>
          </el-form-item>
          <el-form-item label="联系电话:"  >
            <div style="min-width:150px">{{user.mobile}}</div>
          </el-form-item>
          <el-form-item label="是否启用验证码:" :prop="'cFlowNodeList.'+index+'.nodeUserList.'+Uindex+'.isValMobile'" :key="'isValMobile'+Uindex">
           <template >
              <el-radio-group v-model="user.isValMobile" @change="isMFN($event,index,Uindex)">
                <el-radio :label="1" >否</el-radio>
                <el-radio :label="2">是</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
           <el-form-item label="是否短信提醒:" :prop="'cFlowNodeList.'+index+'.nodeUserList.'+Uindex+'.isSmsMobile'" :key="'isSmsMobile'+Uindex">
           <template >
              <el-radio-group v-model="user.isSmsMobile" @change="isMFN($event,index,Uindex)">
                <el-radio :label="1" >否</el-radio>
                <el-radio :label="2">是</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="手机号:"  :prop="'cFlowNodeList.'+index+'.nodeUserList.'+Uindex+'.mobile'" :key="'mobile'+Uindex" :rules="rules.mobile" v-if="user.isValMobile==2||user.isSmsMobile==2">
           <el-input  placeholder="" v-number-input.float="0"   maxlength="11" v-model="user.mobile" ></el-input>
          </el-form-item>
          <el-form-item >
             <el-button type="text" @click="handleClose(user,Uindex,index)"><i class="el-icon-delete"></i></el-button>
          </el-form-item>
         </div>
        </div>
         <hr>
      </div>
      <div class="footerBtn">
      <el-button type="primary" class="bigBtn" @click="saveFn()">确 定</el-button>
    </div>
     <!-- 选择人员 -->
      <el-dialog  title="选择人员"  :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="isEdit" width="1000px" center>
        <div>
           <div class="spry">
              <div class="treeBox" v-if="isCutCrm3!=1">
                <el-form-item label="选择人员:"  >
                  <el-tree
                  :data="tree"
                :props="defaultProps"
                node-key="orgCode"
                ref="tree"
                :default-expand-all="true"
                :highlight-current="true"
                @node-click="handleNodeClick"
                :render-content="renderContent"
                >
                </el-tree>
                </el-form-item>
              </div>
              <div class="tbox">
                <el-table :data="userList"  ref="table" highlight-current-row   max-height="350px" >
                    <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
                    <el-table-column label="操作"  width="50">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini"  @click="handleCurrentChange(scope.row)">选择</el-button>
                      </template>
                  </el-table-column>
                    <el-table-column prop="userName" width="150px" label="用户名"></el-table-column>
                    <el-table-column prop="userAccount"  width="150px" label="登录名"></el-table-column>
                    <el-table-column prop="mobile"   label="电话"></el-table-column>
                  </el-table>
              </div>
          </div>
          <div>
            <el-tag
              v-for="(tag,index) in LCfrom.cFlowNodeList[editIndex].nodeUserList"
               :key="index"
              closable
              :disable-transitions="false"
              @close="handleClose(tag,index,editIndex)">
              {{tag.operationUserName}}
            </el-tag>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEdit = false">关闭</el-button>
          <!-- <el-button type="primary" @click="xzdzFn('addFrom')">确 定</el-button> -->
        </span>
        </el-dialog>
    </el-form>
 </div>
</template>

<script>
import { warehouseList, selectPersonnelTree, updateDetail, CFNdel, updateCFlow, cFlowNodeUserDel } from '@/api/common-signature'
import { sUserList } from '@/api/newCrm'
export default {
  data () {
    let id = this.$route.query.id
    return {
      ywlx: [
        { name: '实捆提货', id: '1' },
        { name: '实捆转货', id: '2' },
        // { name: '发布货源', id: '3' }
        { name: '维修', id: '4' },
        { name: '虚捆提货', id: '5' },
        { name: '虚捆转货', id: '6' }
      ],
      sptj: [
        { name: '货物重量', id: 1 },
        { name: '货物件数', id: 2 }
      ],
      id: id,
      isEdit: false,
      editIndex: 0,
      warehouseList: [],
      LCfrom: {
        tiaojian: [],
        cFlowNodeList: [{ sortNum: 1, nodeUserList: [] }]
      },
      rules: {
        name: [{ required: true, message: '请输入流程名称', trigger: 'blur' }],
        organizationId: [{ required: true, message: '请选择所属仓库', trigger: 'blur' }],
        tiaojian: [{ required: true, message: '请选择审批条件', trigger: 'blur' }],
        formType1: [{ required: true, message: '请选择业务类型', trigger: 'blur' }],
        minWeight: [{ required: true, message: '请输入最小重量', trigger: 'blur' }],
        minNum: [{ required: true, message: '请输入最小件数', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          this.rule.mobile]

      },
      tree: [],
      userList: [],
      isCutCrm3: localStorage.getItem('isCutCrm3'),
      defaultProps: {
        label: 'orgName'
        // id: 'orgCode',
        // // orgCode: 'orgCode',
        // orgName: 'orgName',
        // children: 'children'

      }
    }
  },
  created () {
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        tenantName: localStorage.getItem('createTenantName'),
        tenantCode: localStorage.getItem('createTenantCode')
      }]
      this.$set(this.LCfrom, 'organization', this.warehouseList)
    } else {
      warehouseList().then(res => {
        this.warehouseList = res
      })
    }
    updateDetail({ id: this.id }).then(res => {
      this.LCfrom = res
      this.LCfrom.organization = res.organizationName.split(',')
      this.LCfrom.organizationId = res.organizationId
      this.LCfrom.organizationName = res.organizationName
      this.$set(this.LCfrom, 'tiaojian', [])
      if (res.cFlowNodeList[0].minWeight != -1 && res.cFlowNodeList[0].minNum == -1) {
        this.LCfrom.tiaojian.push(1)
      } else if (res.cFlowNodeList[0].minNum != -1 && res.cFlowNodeList[0].minWeight == -1) {
        this.LCfrom.tiaojian.push(2)
      } else if (res.cFlowNodeList[0].minNum != -1 && res.cFlowNodeList[0].minWeight != -1) {
        this.LCfrom.tiaojian.push(1)
        this.LCfrom.tiaojian.push(2)
      }
      this.$set(this.LCfrom, 'formType1', { name: res.formTypeName, id: res.formType })
      res.cFlowNodeList.forEach((item, index) => {
        if (item.minWeight == -1) {
          this.$set(this.LCfrom.cFlowNodeList[index], 'minWeight', '')
        }
        if (item.minNum == -1) {
          this.$set(this.LCfrom.cFlowNodeList[index], 'minNum', '')
        }
      })
    })
    if (this.isCutCrm3 == 1) {
      sUserList({
        tenantCode: localStorage.getItem('createTenantCode'),
        useTenantCode: localStorage.getItem('tenantCode'),
        isAdmin: 0,
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        this.userList = res.list
      }).catch(err => {
        this.$message.error(err.message)
      })
    } else {
      selectPersonnelTree().then(res => {
        let tree = JSON.parse(res)
        let arr = []
        arr.push(tree)
        this.tree = arr
        this.$nextTick(function () {
          this.userList = tree.users
        })
      })
    }
  },
  mounted () {

  },
  methods: {
    // 保存
    saveFn () {
      this.$refs.LCfrom.validate((valid) => {
        if (valid) {
          let flag = this.LCfrom.cFlowNodeList.some(value => value.nodeUserList.length <= 0)
          if (flag) {
            this.$alert('请选择审批人员', '系统提示')
            return
          }
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.LCfrom.formTypeName = this.LCfrom.formType1.name
          this.LCfrom.formType = this.LCfrom.formType1.id
          updateCFlow(this.LCfrom).then(res => {
            loading.close()
            this.$router.push({ name: 'examine' })
          }).catch(error => {
            loading.close()
            this.$alert(error.message, '系统提示')
          })
        }
      })
    },
    // 修改人员
    editFn (index) {
      this.isEdit = true
      this.editIndex = index
      this.userList = this.tree[0].users
    },
    // 点击树
    handleNodeClick (data) {
      this.userList = data.users
    },
    renderContent (h, { node, data, store }) {
      var n = '(' + node.data.users.length + ')'
      return (
        <span class="custom-tree-node">
          <span>{node.label + n}</span>
        </span>)
    },
    // 修改是否验证手机号
    isMFN (e, index, Uindex) {
      // let flag = this.LCfrom.cFlowNodeList[index].nodeUserList[Uindex].isSmsMobile == 1
      // let flag1 = this.LCfrom.cFlowNodeList[index].nodeUserList[Uindex].isValMobile == 1
      // if (flag && flag1) {
      //   this.$set(this.LCfrom.cFlowNodeList[index].nodeUserList[Uindex], 'mobile', '')
      // }
    },
    // 审批条件更改
    tjFn (e) {
      console.log(e)
      if (e.length == 1) {
        if (e[0] == 1) {
          this.LCfrom.cFlowNodeList.forEach((item, index) => {
            this.$set(this.LCfrom.cFlowNodeList[index], 'minNum', '')
          })
        }
        if (e[0] == 2) {
          this.LCfrom.cFlowNodeList.forEach((item, index) => {
            this.$set(this.LCfrom.cFlowNodeList[index], 'minWeight', '')
          })
        }
      } else if (e.length == 0) {
        this.LCfrom.cFlowNodeList.forEach((item, index) => {
          this.$set(this.LCfrom.cFlowNodeList[index], 'minWeight', '')
          this.$set(this.LCfrom.cFlowNodeList[index], 'minNum', '')
        })
      }
    },
    // 限制重量
    setWeight (index) {
      if (index > 0) {
        var n = Number(this.LCfrom.cFlowNodeList[index].minWeight)
        let m = Number(this.LCfrom.cFlowNodeList[index - 1].minWeight)
        if (n <= m) {
          this.$alert('货物重量需要大于上一个审批节点的货物重量', '系统提示')
        }
      }
    },
    setNum (index) {
      if (index > 0) {
        var n = Number(this.LCfrom.cFlowNodeList[index].minNum)
        let m = Number(this.LCfrom.cFlowNodeList[index - 1].minNum)
        if (n <= m) {
          this.$alert('货物件数需要大于上一个审批节点的货物件数', '系统提示')
        }
      }
    },
    // 点击人员
    handleCurrentChange (row) {
      let flag2 = this.LCfrom.cFlowNodeList[this.editIndex].nodeUserList.some(value => value.operationUserId == row.userCode)
      if (flag2) {
        this.$alert('不能选择重复的用户', '系统提示')
        return
      }
      this.LCfrom.cFlowNodeList[this.editIndex].nodeUserList.push({
        isValMobile: 1,
        isSmsMobile: 1,
        operationUserId: row.userCode,
        operationUserName: row.userName,
        mobile: row.mobile
      })
    },
    // 删除人员
    handleClose (tag, index, editIndex) {
      if (tag.id) {
        this.$confirm('是否执行删除操作?', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cFlowNodeUserDel({ id: tag.id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.LCfrom.cFlowNodeList[editIndex].nodeUserList.splice(index, 1)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      } else {
        this.LCfrom.cFlowNodeList[editIndex].nodeUserList.splice(index, 1)
      }
    },
    // 添加节点
    addNode () {
      if (this.LCfrom.cFlowNodeList.length >= 5) {
        this.$alert('最多只能添加5个审批节点', '系统提示')
      } else {
        let i = this.LCfrom.cFlowNodeList.length + 1
        var json = {
          nodeUserList: [],
          sortNum: i
        }
        this.LCfrom.cFlowNodeList.push(json)
      }
    },
    // 删除
    del (index) {
      if (this.LCfrom.cFlowNodeList.length <= 1) {
        this.$alert('至少需要保留一个审批节点', '系统提示')
      } else {
        this.editIndex = 0
        if (this.LCfrom.cFlowNodeList[index].id) {
          this.$confirm('是否执行删除操作?', '系统提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            CFNdel({ id: this.LCfrom.cFlowNodeList[index].id }).then(res => {
              loading.close()
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.LCfrom.cFlowNodeList.splice(index, 1)
              for (var i = 0; i < this.LCfrom.cFlowNodeList.length; i++) {
                this.$set(this.LCfrom.cFlowNodeList[i], 'sortNum', i + 1)
              }
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {

          })
        } else {
          this.LCfrom.cFlowNodeList.splice(index, 1)
          for (var i = 0; i < this.LCfrom.cFlowNodeList.length; i++) {
            this.$set(this.LCfrom.cFlowNodeList[i], 'sortNum', i + 1)
          }
        }
      }
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.addBox{
  overflow: hidden;
}
.tiaojian /deep/.el-form-item__content{
position: relative;
span{
  position: absolute;
  left: 4px;
  z-index: 99;
}
}
.ck /deep/.el-input__inner{
width: 300px;
}
.spry{
  display: flex;
  margin-bottom: 20px;
  .treeBox{
    flex-shrink:0;
    margin-right: 20px;
    width: 400px;
  }
  .tbox{
    flex-grow:1,
  }
}
.editBtn{
  margin-left: 8px;
  color: #0c46a2;
  font-size: 16px;
}
.nodata{
      display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
/deep/.el-tag{
  margin-right: 10px;
}
/deep/.el-icon-delete{
  font-size: 18px;
}
</style>
